import AppFilter from './AppFilter'
import DateRangeFilter from './DateRangeFilter'
import FilterUpgradeTooltip from './FilterUpgradeTooltip'
import TeamFilter from './TeamFilter'
import type { UsageFiltersState } from './types'
import UserFilter from './UserFilter'

interface UsageFiltersProps {
  enterpriseId: string | null
  value: UsageFiltersState
  onChange: (next: UsageFiltersState) => void
  // When true, every filter is locked behind the upgrade-to-Enterprise tooltip.
  upgradeLocked?: boolean
}

const UsageFilters = ({ enterpriseId, value, onChange, upgradeLocked = false }: UsageFiltersProps) => {
  return (
    <div className="flex items-center gap-4">
      <FilterUpgradeTooltip active={upgradeLocked}>
        <DateRangeFilter
          value={value.date}
          onChange={(date) => onChange({ ...value, date })}
          disabled={upgradeLocked}
        />
      </FilterUpgradeTooltip>
      <FilterUpgradeTooltip active={upgradeLocked}>
        <AppFilter
          enterpriseId={enterpriseId}
          appKeys={value.appKeys}
          appCategories={value.appCategories}
          onChange={({ appKeys, appCategories }) => onChange({ ...value, appKeys, appCategories })}
          disabled={upgradeLocked}
        />
      </FilterUpgradeTooltip>
      <FilterUpgradeTooltip active={upgradeLocked}>
        <UserFilter
          enterpriseId={enterpriseId}
          value={value.userIds}
          onChange={(userIds) => onChange({ ...value, userIds })}
          disabled={upgradeLocked}
        />
      </FilterUpgradeTooltip>
      <FilterUpgradeTooltip active={upgradeLocked}>
        <TeamFilter
          value={value.teamId}
          onChange={(teamId) => onChange({ ...value, teamId })}
          disabled={upgradeLocked}
        />
      </FilterUpgradeTooltip>
    </div>
  )
}

export default UsageFilters
